<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
            <div class="mb-2 font-weight-bold">Configuración</div>
            Sistema
              <select class="form-control" v-model="configuration.SISTEMA">
                <option value="0">Horas</option>
                <option value="1">Grados</option>
              </select>
          </div>
          <div class="col-md-4 mt-2">
            <br/>
            Operación
            <select class="form-control" v-model="configuration.OPERACION">
              <option value="+">Suma</option>
              <option value="-">Resta</option>
            </select>
          </div>
          <div class="col-md-4 mt-2">
            <br/>
            <br/>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
              v-model="configuration.VERBAL_ORAL"
              id="verbaloral">
              <label class="custom-control-label" for="verbaloral">Verbal oral</label>
            </div>
          </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row  class="justify-content-md-center">
          <b-col style="text-align:center"><h6>º</h6></b-col>
          <b-col style="text-align:center"><h6>' </h6></b-col>
          <b-col style="text-align:center"><h6>"</h6></b-col>
          <b-col md="1" style="text-align:center"><h6>+/-</h6></b-col>
          <b-col style="text-align:center"><h6>º</h6></b-col>
          <b-col style="text-align:center"><h6>'</h6></b-col>
          <b-col style="text-align:center"><h6>"</h6></b-col>
          <b-col md="2" style="text-align:center"><h6>Resultado</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col>
                <ValidationProvider rules="required|max:3" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'GRADOS_OP1' + index"
                    v-model="arrayEleOperation[index].GRADOS_OP1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col>
                <ValidationProvider rules="required|max:2" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'MINUTOS_OP1' + index"
                    v-model="arrayEleOperation[index].MINUTOS_OP1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col>
                <ValidationProvider rules="required|max:2" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'SEGUNDOS_OP1' + index"
                    v-model="arrayEleOperation[index].SEGUNDOS_OP1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="1">
                <b-form-input type="text" disabled
                  v-model="configuration.OPERACION">
                  </b-form-input>
              </b-col>
             <b-col>
               <ValidationProvider rules="required|max:3" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'GRADOS_OP2' + index"
                    v-model="arrayEleOperation[index].GRADOS_OP2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col>
                <ValidationProvider rules="required|max:2" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'MINUTOS_OP2' + index"
                    v-model="arrayEleOperation[index].MINUTOS_OP2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col>
                <ValidationProvider rules="required|max:2" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'SEGUNDOS_OP2' + index"
                    v-model="arrayEleOperation[index].SEGUNDOS_OP2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="2">
                <b-form-input disabled
                    v-bind:id="'RESULT' + index"
                    type="text"
                    v-bind:value="getResult(index)" />
              </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('max', {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ['length'],
  message: 'Máx. {length} dígitos',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        OPERACION: '+',
        SISTEMA: 1,
        VERBAL_ORAL: false,
        EJERCICIOS_ID: -1,
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        GRADOS_OP1: 0,
        MINUTOS_OP1: 0,
        SEGUNDOS_OP1: 0,
        OPERACION: '+',
        GRADOS_OP2: 0,
        MINUTOS_OP2: 0,
        SEGUNDOS_OP2: 0,
      });
    },
    getResult(index) {
      let resultg = 0;
      let resultm = 0;
      let results = 0;
      let restosec = 0;
      let restomin = 0;

      // Addition
      if (this.configuration.OPERACION === '+') {
        results = parseInt(this.arrayEleOperation[index].SEGUNDOS_OP1, 10) + parseInt(this.arrayEleOperation[index].SEGUNDOS_OP2, 10);
        while (results >= 60) {
          results -= 60;
          restosec += 1;
        }

        resultm = parseInt(this.arrayEleOperation[index].MINUTOS_OP1, 10) + parseInt(this.arrayEleOperation[index].MINUTOS_OP2, 10);
        resultm += restosec;
        while (resultm >= 60) {
          resultm -= 60;
          restomin += 1;
        }

        resultg = parseInt(this.arrayEleOperation[index].GRADOS_OP1, 10) + parseInt(this.arrayEleOperation[index].GRADOS_OP2, 10);
        resultg += restomin;
      }

      // Substraction
      if (this.configuration.OPERACION === '-') {
        const valS1 = parseInt(this.arrayEleOperation[index].SEGUNDOS_OP1, 10);
        const valS2 = parseInt(this.arrayEleOperation[index].SEGUNDOS_OP2, 10);
        let valM1 = parseInt(this.arrayEleOperation[index].MINUTOS_OP1, 10);
        const valM2 = parseInt(this.arrayEleOperation[index].MINUTOS_OP2, 10);
        let valH1 = parseInt(this.arrayEleOperation[index].GRADOS_OP1, 10);
        const valH2 = parseInt(this.arrayEleOperation[index].GRADOS_OP2, 10);

        // Calculate seconds
        results = valS1 - valS2;
        if (results < 0) {
          results += 60;
          valM1 -= 1;
        }

        // Calculate minutes
        resultm = valM1 - valM2;
        if (resultm < 0) {
          resultm += 60;
          valH1 -= 1;
        }

        // Calculate hours
        resultg = valH1 - valH2;
      }

      const result = `${resultg}º ${resultm}' ${results}"`;
      return result;
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('additionsubtractionsexagesimal/getadditionsubtractionsexagesimal', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            GRADOS_OP1: element.GRADOS_OP1,
            MINUTOS_OP1: element.MINUTOS_OP1,
            SEGUNDOS_OP1: element.SEGUNDOS_OP1,
            OPERACION: element.OPERACION,
            GRADOS_OP2: element.GRADOS_OP2,
            MINUTOS_OP2: element.MINUTOS_OP2,
            SEGUNDOS_OP2: element.SEGUNDOS_OP2,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
